var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"BillingStatus\">\n<a class=\"BillingStatus-shouldTrial link-dark\" ng-show=\"ctrl.canTrial()\" ng-click=\"ctrl.navToUpgrade()\">\n<span>\n{{ 'COMPONENT.BILLING_STATUS.START_TRIAL' | translate }}\n</span>\n</a>\n<a class=\"BillingStatus-trialDaysRemaining link-dark\" ng-show=\"ctrl.showTrialDaysRemaining()\" ng-click=\"ctrl.navToUpgrade()\">{{ 'COMPONENT.BILLING_STATUS.TRIAL_DAYS_REMAINING' | translate:{ 'days': ctrl.getTrialDaysRemaining() } }}</a>\n<a class=\"BillingStatus-shouldUpgrade link-dark\" ng-show=\"ctrl.shouldSubscribe()\" ng-click=\"ctrl.navToUpgrade()\">\n<span>{{ 'COMPONENT.BILLING_STATUS.TRIAL_EXPIRED' | translate }}\n<br/>\n<strong>{{ 'COMPONENT.BILLING_STATUS.UPGRADE_NOW' | translate }}</strong>\n</span>\n</a>\n</div>\n";
var id1="billing.status.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/status/billing.status.html
// module id = 416
// module chunks = 0